import { validateFields } from "../components/assets";
import { ConstantsResponseBoxDto } from "../../../../components/cross/required-documentation/required-doc.dto";
import { FormValues } from "../hooks/hooks.types";
import { FormatedSupplementDoc } from "../utils.type";

export const validateWaitingPeriodData = (
  values: FormValues,
  supplementDocs: FormatedSupplementDoc[]
) => {
  const { errors } = validateFields(values, waitingPeriodRules(supplementDocs));
  const hasValidation = !errors.companiaOrigen && !errors.numPoliza && !errors.documents;
  return { errors, hasValidation };
};

export const waitingPeriodRules = (supplementDocs: FormatedSupplementDoc[]) => {
  const requiredDocs = supplementDocs.filter((doc) => doc.required);

  return {
    companiaOrigen: "required",
    numPoliza: "required",
    documents: (documents: { uploadDocuments: ConstantsResponseBoxDto[] }) => {
      let error = "";
      for (const doc of requiredDocs) {
        if (!documents.uploadDocuments.some((uploadDoc) => uploadDoc.type === doc.value)) {
          error = `${error ? error + " - " : ""}${doc.label}`;
        }
      }
      return error;
    },
  };
};
